(function (scope) {
	scope.DisableCSS = function (callback) {
		var me = this;
		me._startTime = new Date ().getTime ();
		// console.log ("DisableCSS startTime", me._startTime);
		me._callback = callback;
		me._cssFilesToDisable = [];
		// me._cssFilesToDisable.push ("jquery-ui.css");/*jQuery UI*/
		me._cssFilesToDisable.push ("classic-10_7.css");/*mail chimp*/
		me._tries = 0;
		me.disable = function () {
			// console.log ("DisableCSS tries", me._tries, me._cssFilesToDisable);
			// try 100 times
			if (me._tries < 100) {
				me._tries += 1;
				$("link").each (function () {
					var i = 0;
					while (i < me._cssFilesToDisable.length) {
						var cssFile = me._cssFilesToDisable [i];
						if ($(this).attr ("href").indexOf (cssFile) > -1) {
							//disable this
							this.disabled = true;
							me._cssFilesToDisable.splice (i, 1);
						} else {
							i += 1;
						}
					}
				});
				if (me._cssFilesToDisable.length) {
					setTimeout (function () {
						me.disable.apply (me);
					}, 1000 / 24);
				}
			}
			if (me._tries >= 100 || !me._cssFilesToDisable.length) {
				if (typeof (me._callback) == "function") {
					me._callback ();
				}
				me.onDone ();
			}
		}
		me.onDone = function () {
			var timeNow = new Date ().getTime ();
			var elapsedTime = timeNow - me._startTime;
			// console.log ("DisableCSS elapsedTime", elapsedTime);
		};
		setTimeout (function () {
			me.disable.apply (me);
		}, 1000);
	}	
}) (window);
